import { render, staticRenderFns } from "./BlockStatus.vue?vue&type=template&id=25b262ad&scoped=true"
import script from "@/components/request/RequestDetail/block-status/BlockStatus.ts?vue&type=script&lang=ts&external"
export * from "@/components/request/RequestDetail/block-status/BlockStatus.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/request/RequestDetail/block-status/block-status.scss?vue&type=style&index=0&id=25b262ad&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b262ad",
  null
  
)

export default component.exports